import type { ApiUserProfilePatchRequest } from '../api/userProfile/userProfileModels';

import { getAuthToken } from '../api/auth/getAuthToken';
import { userProfileDirectApi } from '../api/userProfile/userProfileDirectApi';

const createDefaultProfile = async () => {
    const identity = await getAuthToken();
    const userAddress = await userProfileDirectApi.createDefaultProfile(identity.token);
    return userAddress;
};

const getProfile = async () => {
    const identity = await getAuthToken();
    const profile = await userProfileDirectApi.getProfile(identity.token);
    return profile;
};

const updateProfile = async (patchRequest: ApiUserProfilePatchRequest) => {
    const identity = await getAuthToken();
    const updatedProfile = await userProfileDirectApi.updateProfile(identity.token, patchRequest);
    return updatedProfile;
};

const getFavoriteProducts = async () => {
    const identity = await getAuthToken();
    const favoriteProducts = await userProfileDirectApi.getAllFavoriteProducts(identity.token);
    return favoriteProducts;
};

const addFavoriteProduct = async (productId: string) => {
    const identity = await getAuthToken();
    const addedProduct = await userProfileDirectApi.addFavoriteProduct(identity.token, productId);
    return addedProduct;
};

const removeFavoriteProduct = async (productId: string) => {
    const identity = await getAuthToken();
    await userProfileDirectApi.removeFavoriteProduct(identity.token, productId);
};

const userProfileFlow = {
    getProfile,
    createDefaultProfile,
    updateProfile,
    favoriteProducts: {
        getAll: getFavoriteProducts,
        add: addFavoriteProduct,
        remove: removeFavoriteProduct,
    },
};

export default userProfileFlow;
